// extracted by mini-css-extract-plugin
export default {"link":"link_link__mhDtx","link-black":"link_link-black__DWvcG","link-white":"link_link-white__WkGiI","footerLink":"link_footerLink__nM5Z7","activeLink":"link_activeLink__UVHyB"};